//meta data field type
$('input[data-action="meta_data"]').keyup(function() {

    var input = $(this);
    var meta_id = $(this).data('meta_id');
    var s = $(this).val();
    if(s.length<1){
        $(".suggestions-"+meta_id).remove();
        return;
    }

    var url = meta_data_url.replace('meta_id',meta_id).replace('search',s);

    var jqxhr = $.getJSON(url, function(data) {
        if(data.result==1){
            if(data.meta_data.length>0){
                $(".suggestions-"+meta_id).remove();
                input.after('<div class="suggest suggestions-'+meta_id+'"><ul></ul></div>');
                for(var i=0; i<=(data.meta_data.length)-1; i++){
                    $(".suggestions-"+meta_id+" ul").append('<li><a data-index="'+i+'" data-meta_id="'+meta_id+'" href="javascript:loadMetaData(\''+meta_id+'\','+i+')"></a></li>');
                    var subfields = data.meta_data[i].data;
                    $.each(subfields, function( index, value ) {
                        if(index==input.attr('name')){
                            $(".suggestions-"+meta_id+" ul li a[data-index="+i+"]").html(value);
                        }
                        $(".suggestions-"+meta_id+" ul li a[data-index="+i+"]").attr('data-'+index,value);
                    });
                }
            }
        }
        })
    .done(function() {
        //console.log( "second success" );
    })
    .fail(function() {
        console.log( "error" );
    })
    .always(function() {
        console.log( "complete" );
    });


});
